import React, { useContext, useEffect, useState } from 'react';
import { NavigationWrapper, PickerHOC, UiWrapper } from '@coinscrap/webapp-core';

import Header from 'layout/components/Header/Header';

import LoadingScreen from 'components/LoadingScreen/LoadingScreen';

import { useInitialScrollToTop } from 'hooks/useInitialScrollToTop';

import { AgentContext } from '../../contexts/agent';
import { useLoginClient } from './hooks/useLoginClient';

export const LoginClient = PickerHOC(
	{},
	LoadingScreen,
)(() => {
	const { setInitialValues, setBmwValues, setRastreatorValues } = useContext(AgentContext);
	const { useHeader, useLoading } = UiWrapper.use();
	const { query } = NavigationWrapper.use();

	useEffect(() => {
		console.log('query?.from', query?.from);
		if (query?.from === undefined) {
			setInitialValues();
		} else if (query?.from === 'bmw') {
			setBmwValues();
		} else if (query?.from === 'rastreator') {
			setRastreatorValues();
		}
		return () => {};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [query?.from]);

	const { loading } = useLoginClient();

	useLoading(loading, { loadingMessage: loading });
	useHeader(<Header />, []);
	useInitialScrollToTop();

	return <></>;
});
